/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';

export default function AutoSummaryReadOnly(props)
{
    const [autoSummaryReadOnly, setShowC3] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setShowC3(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleAutoSummaryReadOnly = () => {
        setShowC3(!autoSummaryReadOnly);
        props.onChange(!autoSummaryReadOnly)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={autoSummaryReadOnly}
                        onChange={handleAutoSummaryReadOnly}
                        name="AutoSummaryReadOnly"
                        color="primary"
                        />
                    }
                    label="Make AutoSummary Read Only"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Makes Auto Summary Read Only">
                        <LocalAtmIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

